import { Vue, Component, Ref, Prop, Emit, Provide } from 'vue-property-decorator'
import { initialSampleProcessesModalState, IContentSampleProcessesGrid } from '@/modules/configurationModule/detail/samples/processesTypes/SampleProcesses.models'
import ConfigurationFieldsTranslations from '@/modules/configurationModule/shared/components/configuration-fields-translations/configuration-fields-translations.vue'
import { cloneDeep, isNil } from 'lodash'
import { BModal } from 'bootstrap-vue'

@Component({
    components: {
        ConfigurationFieldsTranslations
    }
})
export default class SampleProcessesModal extends Vue {
    @Ref() readonly sampleProcessesModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    update(sampleProcesses: IContentSampleProcessesGrid[]): IContentSampleProcessesGrid[] {
        return sampleProcesses
    }

    @Emit()
    create(sampleProcesses: IContentSampleProcessesGrid): IContentSampleProcessesGrid {
        return sampleProcesses
    }

    state: IContentSampleProcessesGrid
    constructor() {
        super()
        this.state = initialSampleProcessesModalState()
    }

    private get _hasDefaultLanguage(): boolean {
        const defaultLanguage = this.state.nameTranslations?.find(translation => translation.language.defaultLanguage)
        if (defaultLanguage) {
            return !!defaultLanguage.value?.length
        }
        return false
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        const codeValidated = isNil(this.state.code) ? false : this.state.code >= 0
        return !hasErrors && isDirty && codeValidated && this._hasDefaultLanguage
    }

    async show(selectedRow: IContentSampleProcessesGrid): Promise<void> {
        this.state = initialSampleProcessesModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this.state = {
                ...cloneDeep(selectedRow)
            }
        }
        this.sampleProcessesModal.show()
    }

    hide(): void {
        this.sampleProcessesModal.hide()
    }

    actionModal(): void {
        if (this.state?.id) {
            this.update([this.state])
        } else {
            this.create(this.state)
        }
    }
}
